<header
  class="header ios-padding-left ios-padding-right"
  [elevation]="4"
  appElevation
>
  <button
    im-icon-button
    class="header__navigation-toggle"
    [attr.aria-label]="
      (navigationOpen()
        ? 'navigation.collapse_sidebar_a'
        : 'navigation.expand_sidebar_a'
      ) | translate
    "
    [attr.aria-expanded]="navigationOpen()"
    (click)="onNavigationToggleClick($event)"
  >
    <i
      class="icon"
      [class.icon--close]="navigationOpen()"
      [class.icon--context]="!navigationOpen()"
      aria-hidden="true"
    ></i>
  </button>

  <app-logo></app-logo>

  <nav class="header__nav">
    <div class="header__nav-item header__nav-item--search">
      <ng-content select="[search-field]"></ng-content>
    </div>

    <div class="header__nav-item header__nav-item--user-menu">
      @if (user() && user().profile) {
        <app-avatar
          class="header__profile-settings-toggle"
          [imgSrc]="user()?.profile?.portrait | appImageSize: 'S'"
          name="{{ user()?.profile?.firstname }} {{ user()?.profile?.name }}"
          [size]="'small'"
          (click)="onProfileSettingsToggleClick($event)"
        ></app-avatar>
      } @else {
        <button
          im-icon-button
          class="header__profile-settings-toggle"
          [attr.aria-label]="'header.account_settings_l' | translate"
          [attr.aria-expanded]="profileSettingsOpen()"
          (click)="onProfileSettingsToggleClick($event)"
        >
          <i
            class="icon"
            [class.icon--close]="profileSettingsOpen()"
            [class.icon--user]="!profileSettingsOpen()"
            aria-hidden="true"
          ></i>
        </button>
      }
    </div>
  </nav>
</header>
